import { useState } from "react";
import { errText, postJson } from "@/lib/api";

function Result({ res }) {
  return (
    <div className="adm-result" data-testid="admin-add-result">
      <p><b className="num">{res.added.length}</b> added · <b className="num">{res.skipped.length}</b> skipped</p>
      {res.added.length ? <ul className="adm-list ok" data-testid="admin-added-list">{res.added.map(e => <li key={e}><span className="num">{e}</span><em>Added</em></li>)}</ul> : null}
      {res.skipped.length ? <ul className="adm-list skip" data-testid="admin-skipped-list">{res.skipped.map((s, i) => <li key={s.email + i}><span className="num">{s.email}</span><em>{s.reason}</em></li>)}</ul> : null}
    </div>
  );
}

export function AddCard({ onAdded }) {
  const [text, setText] = useState(""), [busy, setBusy] = useState(false), [res, setRes] = useState(null), [err, setErr] = useState("");
  const submit = async e => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await postJson("/api/admin/access", { emails: text }), d = await r.json();
      if (r.ok) { setRes(d); setText(""); onAdded(); } else setErr(errText(d));
    } catch (x) { setErr("Network error. Please try again."); }
    setBusy(false);
  };
  return (
    <div className="card span-5" data-testid="admin-add-card">
      <div className="kpi-label">Manage access</div>
      <h2 style={{ marginTop: "4px" }}>Add people</h2>
      <p className="sub">Paste one or more email addresses, separated by commas or new lines. People on this list can sign in with the email code, whatever their email domain.</p>
      <form onSubmit={submit}>
        <label className="adm-label" htmlFor="adm-emails">Email addresses</label>
        <textarea id="adm-emails" className="adm-textarea" rows={6} value={text} onChange={e => setText(e.target.value)} placeholder={"name@partner.org\nsecond.person@example.org"} data-testid="admin-emails-input" />
        {err ? <div className="adm-msg err" role="alert" data-testid="admin-add-error">{err}</div> : null}
        <button className="adm-primary" type="submit" disabled={busy || !text.trim()} data-testid="admin-add-btn">{busy ? "Adding…" : "Add to access list"}</button>
      </form>
      {res ? <Result res={res} /> : null}
    </div>
  );
}
